import * as React from 'react';
import { LegalGrid, LegalContent } from '../../components/UI/LegalUI';
import TopBar from '../Site/TopBar';
import { withThemer, ThemerProps } from '../../helpers/withThemer';
import { ThemeProvider } from 'styled-components';
import LegalHead from '../Site/LegalHead';
import Footer from '../Site/Footer';
import LegalNav from '../Site/LegalNav';

interface DashProps {
  children: React.ReactNode;
}

type Props = ThemerProps & DashProps;

const LegalLayout: React.SFC<Props> = ({ children, theme, updateTheme }) => (
  <ThemeProvider theme={{ mode: theme }}>
    <LegalGrid>
      <LegalHead>
        <TopBar />
      </LegalHead>
      <LegalNav />
      <LegalContent>{children}</LegalContent>
      <Footer />
    </LegalGrid>
  </ThemeProvider>
);

export default withThemer(LegalLayout);



// WEBPACK FOOTER //
// ./src/containers/Layouts/LegalLayout.tsx